import React from 'react';
import { Container } from './styles';
import hpLogoImg from 'src/assets/images/Logo.svg';
import { Button } from '@veneer/core';
import useShellRootContext from 'src/contexts/ShellRoot/useShellRootContext';
import { FinishingSetupScreen } from '../FinishingSetupScreen';

interface HpxLoadingScreenProps {
  isLoggedIn: boolean;
  handleTryAgain: () => void;
  handleCancel: () => void;
}

export const HpxLoadingScreen: React.FC<HpxLoadingScreenProps> = ({
  isLoggedIn,
  handleTryAgain,
  handleCancel
}) => {
  if (isLoggedIn) return <FinishingSetupScreen />;

  return (
    <SignInScreen
      handleTryAgain={handleTryAgain}
      handleCancel={handleCancel}
    />
  );
};

interface SignInScreenProps {
  handleTryAgain: () => void;
  handleCancel: () => void;
}

const SignInScreen: React.FC<SignInScreenProps> = ({
  handleTryAgain,
  handleCancel
}) => {
  const { t } = useShellRootContext();

  return (
    <Container data-testid="hpx-loading-screen">
      <img
        src={hpLogoImg}
        alt="HP Logo"
      />
      <h2>
        {t(
          'loadingScreen.signInBrowser',
          'Finish signing in with your browser'
        )}
      </h2>
      <span>
        {t('loadingScreen.troubleMessage', 'Having some trouble?')}{' '}
        <button
          type="button"
          onClick={handleTryAgain}
          data-testid="hpx-try-again-button"
        >
          {t('loadingScreen.tryAgain', 'Try again')}
        </button>
      </span>
      <Button
        onClick={handleCancel}
        small
        type="button"
        data-testid="hpx-cancel-button"
      >
        {t('loadingScreen.cancel', 'Cancel')}
      </Button>
    </Container>
  );
};
